/* eslint-disable func-names */
/* eslint-disable react/display-name */
/* eslint-disable react/jsx-props-no-spreading */

import React, { Suspense, ComponentType } from 'react';

const Loadable = (Component: ComponentType<any>) =>
  function (props: any) {
    return (
      <Suspense fallback={<></>}>
        <Component {...props} />
      </Suspense>
    );
  };

export default Loadable;
